export var KlevuTypeOfRequest;
(function (KlevuTypeOfRequest) {
    KlevuTypeOfRequest["Search"] = "SEARCH";
    KlevuTypeOfRequest["Suggestion"] = "AUTO_SUGGESTIONS";
    KlevuTypeOfRequest["CategoryNavigation"] = "CATNAV";
    KlevuTypeOfRequest["NewArrivals"] = "RECS_NEW_ARRIVALS";
    KlevuTypeOfRequest["SimilarProducts"] = "RECS_SIMILAR";
    KlevuTypeOfRequest["Trending"] = "RECS_TRENDING";
    KlevuTypeOfRequest["AlsoViewed"] = "RECS_ALSO_VIEWED";
    KlevuTypeOfRequest["AlsoBought"] = "RECS_ALSO_BOUGHT";
    KlevuTypeOfRequest["VisuallySimilar"] = "RECS_SIMILAR_IMAGES";
    KlevuTypeOfRequest["Custom"] = "RECS_CUSTOM";
    // Special type where we skip request to Klevu services, but run everything else
    KlevuTypeOfRequest["Skip"] = "SKIP";
})(KlevuTypeOfRequest || (KlevuTypeOfRequest = {}));
